var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReallocated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.50006,
    r: 7.5,
    fill: "#FFD8BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.375 9.81256C10.0643 9.81256 9.8125 10.0644 9.8125 10.3751C9.8125 10.6857 10.0643 10.9376 10.375 10.9376C10.6857 10.9376 10.9375 10.6857 10.9375 10.3751C10.9375 10.0644 10.6857 9.81256 10.375 9.81256ZM8.6875 10.3751C8.6875 9.44308 9.44302 8.68756 10.375 8.68756C11.307 8.68756 12.0625 9.44308 12.0625 10.3751C12.0625 11.307 11.307 12.0626 10.375 12.0626C9.44302 12.0626 8.6875 11.307 8.6875 10.3751Z",
    fill: "#FA541C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8125 3.62506C3.8125 3.3144 4.06434 3.06256 4.375 3.06256H8.875C9.42201 3.06256 9.94661 3.27986 10.3334 3.66665C10.7202 4.05345 10.9375 4.57805 10.9375 5.12506C10.9375 5.67207 10.7202 6.19668 10.3334 6.58347C9.94661 6.97026 9.42201 7.18756 8.875 7.18756H4.375C4.0269 7.18756 3.69306 7.32584 3.44692 7.57198C3.20078 7.81812 3.0625 8.15196 3.0625 8.50006C3.0625 8.84816 3.20078 9.182 3.44692 9.42814C3.69306 9.67428 4.0269 9.81256 4.375 9.81256H9.25C9.56066 9.81256 9.8125 10.0644 9.8125 10.3751C9.8125 10.6857 9.56066 10.9376 9.25 10.9376H4.375C3.72853 10.9376 3.10855 10.6808 2.65143 10.2236C2.19431 9.76651 1.9375 9.14653 1.9375 8.50006C1.9375 7.8536 2.19431 7.23361 2.65143 6.77649C3.10855 6.31937 3.72853 6.06256 4.375 6.06256H8.875C9.12364 6.06256 9.3621 5.96379 9.53791 5.78797C9.71373 5.61216 9.8125 5.3737 9.8125 5.12506C9.8125 4.87642 9.71373 4.63796 9.53791 4.46215C9.3621 4.28633 9.12364 4.18756 8.875 4.18756H4.375C4.06434 4.18756 3.8125 3.93572 3.8125 3.62506Z",
    fill: "#FA541C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReallocated);
export default __webpack_public_path__ + "static/media/Reallocated.8c0f4cc2.svg";
export { ForwardRef as ReactComponent };